export const formButtonClasses = {
    root: 'BinoFormButtons_root',
    saveButton: 'BinoFormButtons_save',
    backButton: 'BinoFormButtons_back',
};
